import { dataLink } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLink = /*#__PURE__*/createIcon(dataLink)
export default IconLink
